import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { AuthGuard } from './services/auth-gaurd/auth.guard';
import { LoggedinService } from './services/login/loggedin.service';
import {Menus} from './models/menus/menus';
import { SessionHelper } from './shared/services/localstorage';
import { SpeakerListComponent } from './components/speaker/speaker-list/speaker-list.component';
import { VenueListComponent } from './components/venue/venue-list/venue-list.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';

// import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
const role = SessionHelper.getSession() ? SessionHelper.getSession().role_id : 0;
// console.log(SessionHelper.getSession().role_id);
const menuList = {
    dashboard: true,
    createEvent: false,
    myEvents: false,
    Speaker: false,
    Training: false,
    uploadReferenceMaterial: false,
    manageSpeakerContent: false,
    myStory: false,
    venue: false,
    attendeeListing: false,
    myProfile: false,
    addExpense: false,
    reconcileExpense: false,
    reports: false,
    searchSpeaker: false,
    addSpeaker: false,
    searchVenue: false,
    addVenue: false,
    upcomingEventFilter: true,
    notificationsFilter: false,
    editVenue: false,
    initiatetraining: false
}
if(role === 3) {
  menuList.dashboard = true;
  menuList.createEvent = true;
  menuList.myEvents = true;
  menuList.Speaker = true;
  menuList.searchSpeaker = true;
  menuList.venue = true;
  menuList.searchVenue = true;
  menuList.notificationsFilter = false;
  menuList.manageSpeakerContent = false;
  menuList.editVenue = false;
  menuList.initiatetraining = false;
}
else {
  menuList.dashboard = true;
  menuList.createEvent = true;
  menuList.myEvents = true;
  menuList.Speaker = true;
  menuList.searchSpeaker = true;
  menuList.addSpeaker = true;
  menuList.Training = true;
  menuList.uploadReferenceMaterial = true;
  menuList.manageSpeakerContent = true;
  menuList.myStory = true;
  menuList.attendeeListing = true;
  menuList.myProfile = true;
  menuList.addExpense = true;
  menuList.reconcileExpense = true;
  menuList.reports = true;
  menuList.venue = true;
  menuList.searchVenue = true;
  menuList.addVenue = true;
  menuList.notificationsFilter = true;
  menuList.editVenue = true;
  menuList.initiatetraining = true;
}
const menu = JSON.parse(LoggedinService.getMenuList()) || menuList;
console.log(menu)
const routes: Routes = [
  {
    path: '',
    loadChildren: './components/login/login.module#LoginModule'
  },
  {
    path: 'login',
    loadChildren: './components/login/login.module#LoginModule'
  },
  {
    path: 'forgot-password',
    loadChildren: './components/login/forgot-password/forgot-password.module#ForgotPasswordModule'
  },
  {
    path: 'resetpassword/:token',
    loadChildren: './components/login/reset-password/reset-password.module#ResetPasswordModule'
  },
  {
    path: 'profile',
    loadChildren: './components/my-profile/my-profile.module#MyProfileModule',
    canActivate: [AuthGuard],
    data: {isRouteAccess: menu.myProfile}
  },
  {
    path: 'dashboard',
    // loadChildren: './components/dashboard/dashboard.module#DashboardModule',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: {isRouteAccess: menu.dashboard}
  },
  {
    path: 'venue/list',
    loadChildren: './components/venue/venue-list/venue-list.module#VenueListModule',
    // component: VenueListComponent,
    canActivate: [AuthGuard],
    data: {isRouteAccess: menu.venue}
  },
  {
    path: 'training',
    loadChildren: './components/training/training.module#TrainingModule',
    canActivate: [AuthGuard],
    data: {isRouteAccess: menu.Training}
  },
  {
    path: 'initiatetraining',
    loadChildren: './components/initiate-training/initiate-training.module#InitiateTrainingModule',
    canActivate: [AuthGuard],
    data: {isRouteAccess: "true"}
  },
  {
    path: 'upcoming-programs-filter',
    loadChildren: './components/upcoming-filter/upcoming-filter.module#UpcomingFilterModule',
    canActivate: [AuthGuard],
    data: {isRouteAccess: menu.upcomingEventFilter}
  },
  {
    path: 'task-filter',
    loadChildren: './components/task-filter/task-filter.module#TaskFilterModule',
    canActivate: [AuthGuard],
    data: {isRouteAccess: 'true'}
  },
  {
    path: 'notification-filter',
    loadChildren: './components/notification-filter/notification-filter.module#NotificationFilterModule',
    canActivate: [AuthGuard],
    data: {isRouteAccess: menu.notificationsFilter}
  },
  {
    path: 'speaker/create',
    loadChildren: './components/speaker/addspeaker/addspeaker.module#AddspeakerModule',
    canActivate: [AuthGuard],
    data: {isRouteAccess: menu.addSpeaker}
  },
  {
    path: 'speaker/manage/content',
    loadChildren: './components/speaker/managespeakercontent/managespeakercontent.module#ManagespeakercontentModule',
    canActivate: [AuthGuard],
    data: {isRouteAccess: menu.manageSpeakerContent}
  },
  {
    path: 'upload-reference',
    loadChildren: './components/upload-references/upload-references.module#UploadReferencesModule',
    canActivate: [AuthGuard],
    data: {isRouteAccess: menu.uploadReferenceMaterial}
  },
  {
    path: 'venue/create',
    loadChildren: './components/venue/add-venue/add-venue.module#AddVenueModule',
    canActivate: [AuthGuard],
    data: {isRouteAccess: menu.addVenue}
  },
  {
    path: 'event/create',
    loadChildren: './components/event/create-event/create-event.module#CreateEventModule',
    canActivate: [AuthGuard],
    data: {isRouteAccess: "true"}
  },
  {
    path: 'event/edit/:id',
    loadChildren: './components/event/create-event/create-event.module#CreateEventModule',
    canActivate: [AuthGuard],
    data: {isRouteAccess: "true"}
  },
  {
    path: 'event/details/:id',
    loadChildren: './components/event/event-details/event-details.module#EventDetailsModule',
    canActivate: [AuthGuard],
    data: {isRouteAccess: "true"}
  },
  {
    path: 'event/reconcile-event/:id',
    loadChildren: './components/event/reconcile-event/reconcile-event.module#ReconcileEventModule',
    canActivate: [AuthGuard],
    data: {isRouteAccess: "true"}
  }, 
  // {
  //   path: 'attendee-list',
  //   loadChildren: './components/attendee-list/attendee-list.module#AttendeeListModule',
  //   canActivate: [AuthGuard],
  //   data: {isRouteAccess: "true"}
  // }, 
  {
    path: 'venue/edit/:id',
    loadChildren: './components/venue/edit-venue/edit-venue.module#EditVenueModule',
    canActivate: [AuthGuard],
    data: {isRouteAccess: menu.editVenue}
  }, 
  {
    path: 'my-events/list',
    loadChildren: './components/event/my-events/my-events-list/my-events-list.module#MyEventsListModule',
    canActivate: [AuthGuard],
    data: {isRouteAccess: menu.myEvents}
  },
  {
    path: 'my-events/calendar',
    loadChildren: './components/event/my-events/calender/calender.module#CalenderModule',
    canActivate: [AuthGuard],
    data: {isRouteAccess: menu.myEvents}
  },
  {
    path: 'venue/details/:id',
    loadChildren: './components/venue/venue-details/venue-details.module#VenueDetailsModule',
    canActivate: [AuthGuard],
    data: {isRouteAccess: 'true'}
  },
  {
    path: 'speaker/list',
    loadChildren: './components/speaker/speaker-list/speaker-list.module#SpeakerListModule',
    // component: SpeakerListComponent,
    canActivate: [AuthGuard],
    data: {isRouteAccess: menu.searchSpeaker}
  },
  {
    path: 'speaker/edit/:id',
    loadChildren: './components/speaker/speaker-edit/speaker-edit.module#SpeakerEditModule',
    canActivate: [AuthGuard],
    data: {isRouteAccess: menu.addSpeaker}
  },
  {
    path: 'speaker/details/:id',
    loadChildren: './components/speaker/speaker-details/speaker-details.module#SpeakerDetailsModule',
    canActivate: [AuthGuard],
    data: {isRouteAccess: menu.searchSpeaker}
  },
  {
    path: 'reports',
    loadChildren: './components/reports/reports.module#ReportsModule',
    canActivate: [AuthGuard],
    data: {isRouteAccess: menu.reports}
  },
  {
    path: '**',
    redirectTo: 'dashboard'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
 }
